<section class="items-editor card p-3 mb-3" [formGroup]="form">
  <h2>Editar examen</h2>
  <p class="edit-hint">Puedes modificar el nombre y las preguntas mientras no existan evaluaciones.</p>

  <mat-form-field class="full-width" appearance="outline">
    <mat-label>Nombre</mat-label>
    <input matInput formControlName="name" />
  </mat-form-field>

  <div class="items-section">
    <div class="items-section-header">
      <h3>Preguntas</h3>
      @if (total_minutes_preview() > 0) {
        <p class="total-minutes">
          Tiempo total estimado: <strong>{{ total_minutes_preview() }} min</strong>
        </p>
      }
    </div>

    <div class="add-item-row">
      <mat-form-field class="add-item-select" appearance="outline">
        <mat-label>Añadir pregunta</mat-label>
        <mat-select [value]="selected_skill_question_id()" (selectionChange)="onSkillQuestionToAddSelected($event.value)">
          @for (skill_question of available_skill_questions(); track skill_question.id) {
            <mat-option [value]="skill_question.id">
              #{{ skill_question.id }} — {{ skill_question.body }}
              @if (skill_question.approximate_minutes) {
                ({{ skill_question.approximate_minutes }} min)
              }
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <button mat-stroked-button type="button" [disabled]="selected_skill_question_id() === null" (click)="addItemFromSelector()">
        <mat-icon>add</mat-icon>
        Añadir
      </button>
    </div>

    @if (items_form_array.length === 0) {
      <p class="empty-hint">No hay preguntas en el examen.</p>
    }

    @for (item_control of items_form_array.controls; track $index; let item_index = $index) {
      <div class="item-row" [formGroup]="$any(item_control)">
        <span class="item-order">{{ item_index + 1 }}</span>
        <span class="item-label">
          {{ getSkillQuestionLabel($safeNavigationMigration(item_control.get('skill_question_id')?.value)) }}
        </span>
        <span class="item-minutes">{{
          getSkillQuestionMinutesLabel($safeNavigationMigration(item_control.get('skill_question_id')?.value))
        }}</span>
        <mat-form-field appearance="outline" class="small weight-field">
          <mat-label>Peso</mat-label>
          <input matInput type="number" formControlName="weight" min="0.01" step="0.1" />
        </mat-form-field>
        <div class="item-actions">
          <button mat-icon-button type="button" aria-label="Subir" [disabled]="item_index === 0" (click)="moveItemUp(item_index)">
            <mat-icon>arrow_upward</mat-icon>
          </button>
          <button
            mat-icon-button
            type="button"
            aria-label="Bajar"
            [disabled]="item_index === items_form_array.length - 1"
            (click)="moveItemDown(item_index)"
          >
            <mat-icon>arrow_downward</mat-icon>
          </button>
          <button mat-icon-button type="button" color="warn" aria-label="Quitar" (click)="removeItem(item_index)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    }
  </div>

  <div class="save-row">
    <button mat-flat-button color="accent" type="button" [disabled]="loading() || form.invalid" (click)="save()">Guardar cambios</button>
  </div>
</section>
